import type { Campaign } from '@/data'
import api from '..'

export async function getCampaign(id: string): Promise<Campaign | null> {
  const res = await api.get(`/campaigns/${id}`)
  return res.data.data
}
